import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import styles from "../side-nav-bar/SideNavBar.module.css";

const SideDisplay = ({ children, content, listActions = null, style = null }) => {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [arrowTop, setArrowTop] = useState(20);

  const triggerRef = useRef(null);
  const panelRef = useRef(null);

  const toggle = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  useLayoutEffect(() => {
    if (!open) return;

    const calculateInitialPosition = () => {
      const triggerRect = triggerRef.current.getBoundingClientRect();

      requestAnimationFrame(() => {
        if (!panelRef.current) return;

        const panelHeight = panelRef.current.offsetHeight;

        const top = triggerRect.top - panelHeight / 2 + triggerRect.height / 2;
        const left = triggerRect.right + 10;

        setPosition({ top, left });

        // Calculate arrow position INSIDE popup
        const triggerCenter = triggerRect.top + triggerRect.height / 2;
        const arrowPositionInsidePopup = triggerCenter - top;

        setArrowTop(arrowPositionInsidePopup);
      });
    };

    const handleResize = () => {
      setOpen(false);
    };

    calculateInitialPosition();

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleResize, true);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleResize, true);
    };
  }, [open]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div
        ref={triggerRef}
        onClick={toggle}
        style={{ display: "inline-block", cursor: "pointer" }}
      >
        {children}
      </div>

      {open &&
        createPortal(
          <div
            ref={panelRef}
            className={styles.popupPanel}
            style={{
              position: "absolute",
              top: position.top,
              left: position.left,
              "--bg-color": style?.backgroundColor || "white",
              "--arrow-top": `${arrowTop}px`, // dynamic arrow position
            }}
          >
            {listActions ? (
              <div className={styles.popupList}>
                {Object.entries(listActions).map(([label, data]) => (
                  <div
                    key={label}
                    onClick={() => {
                      data.action();
                      setOpen(false);
                    }}
                    className={styles.popupListItem}
                    style={{
                      color: style?.textColor || "black",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = style.hoverColor;
                      data.onMouseEnter?.();
                    }}
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "transparent")
                    }
                  >
                    {data.icon && (
                      <img
                        src={data.icon}
                        alt=""
                        className={styles.popupIcon}
                      />
                    )}
                    <span>{label}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div>{content}</div>
            )}
          </div>,
          document.body,
        )}
    </>
  );
};

export default SideDisplay;
